import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'

import { IFeeSchedule } from './feeSchedule'
import { ODataService } from 'common-services'

export interface IRevenueCodeFee extends IModelBase {
  Amount: number
  Code: string
  Description: string
  FeeScheduleId: number
  FeeSchedule: IFeeSchedule
}

@Injectable()
export class RevenueCodeFeeODataService extends ODataService<IRevenueCodeFee> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'RevenueCodeFees'
  }
}
